var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBody(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0014 10.8547C16.1567 10.8547 17.0932 9.91816 17.0932 8.76291C17.0932 7.60766 16.1567 6.67114 15.0014 6.67114C13.8462 6.67114 12.9097 7.60766 12.9097 8.76291C12.9097 9.91816 13.8462 10.8547 15.0014 10.8547Z",
    stroke: "#29C88B",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.63129 14.6395H12.8385V16.5903L9.4329 21.5912C9.17666 21.9053 9.20146 22.3682 9.4825 22.6575L9.69741 22.8724C10.0198 23.1948 10.5571 23.1782 10.8546 22.8311L14.2189 18.4584H15.4836L18.9057 23.046C19.2033 23.4014 19.7488 23.4262 20.0712 23.0956L20.2779 22.8889C20.5672 22.5996 20.592 22.1367 20.3275 21.8226L16.7814 16.706V14.6974L20.3688 14.6478C20.8895 14.6395 21.3111 14.2179 21.3111 13.6972C21.3111 13.1681 20.8813 12.7466 20.3605 12.7466H16.0705H13.5907H9.63129C9.11053 12.7466 8.68896 13.1681 8.68896 13.6889C8.68896 14.2179 9.11053 14.6395 9.63129 14.6395Z",
    stroke: "#29C88B",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBody);
export default __webpack_public_path__ + "static/media/Body.e2f957e3bea0aee1cf19e4c0e9c16306.svg";
export { ForwardRef as ReactComponent };